import { decodeState, encodeState } from './Registry'

export class BlockState {
  constructor() {
    this.id = 'air'
    this.props = {}
  }

  fromString(str) {
    const { id, props } = decodeState(str)
    this.id = id
    this.props = props
    return this
  }

  toString() {
    return encodeState({ id: this.id, props: this.props })
  }
}
